import { Card, CardContent } from "@/components/ui/card";
import { Leaf, Droplets, Recycle, Shield, Sprout, Wind } from "lucide-react";

const EcoSection = () => {
  const ecoFeatures = [
    {
      icon: Leaf,
      title: "Produits Respectueux",
      description: "Utilisation privilégiée de produits d'entretien respectueux de l'environnement"
    },
    {
      icon: Droplets,
      title: "Gestion de l'Eau",
      description: "Techniques optimisant la consommation d'eau lors de nos interventions"
    },
    {
      icon: Recycle,
      title: "Tri des Déchets",
      description: "Tri sélectif et gestion responsable des déchets de nettoyage"
    },
    {
      icon: Wind,
      title: "Qualité d'Air",
      description: "Sélection de produits limitant les émissions de composés volatils"
    },
    {
      icon: Sprout,
      title: "Démarche Responsable",
      description: "Engagement dans une approche plus respectueuse de l'environnement"
    },
    {
      icon: Shield,
      title: "Normes de Sécurité",
      description: "Respect des normes de sécurité et d'hygiène en vigueur"
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-secondary/5 via-background to-primary/5 relative overflow-hidden">
      {/* Decorative elements */}
      <div className="absolute top-20 right-10 w-64 h-64 bg-secondary/10 rounded-full blur-3xl animate-pulse"></div>
      <div className="absolute bottom-20 left-10 w-96 h-96 bg-primary/10 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '1s' }}></div>
      
      <div className="container mx-auto px-4 relative z-10">
        <div className="text-center mb-16 animate-fade-up">
          <div className="inline-flex items-center gap-2 bg-secondary/20 backdrop-blur-sm px-4 py-2 rounded-full mb-4">
            <Leaf className="h-5 w-5 text-secondary" />
            <span className="text-secondary font-semibold">Notre Approche</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold mb-6" style={{ fontFamily: 'Poppins, sans-serif' }}>
            Nettoyage Professionnel et{" "}
            <span className="bg-gradient-secondary bg-clip-text text-transparent">
              Responsable
            </span>
          </h2>
          <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
            Chez EPP, nous nous efforçons d'allier efficacité et respect de l'environnement dans nos prestations de nettoyage professionnel.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto">
          {ecoFeatures.map((feature, index) => (
            <Card 
              key={index} 
              className="group hover:shadow-xl hover:border-secondary/50 transition-all duration-300 hover:-translate-y-2 bg-background/80 backdrop-blur-sm animate-fade-up"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <CardContent className="pt-6">
                <div className="bg-gradient-secondary w-14 h-14 rounded-xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300 shadow-lg">
                  <feature.icon className="h-7 w-7 text-secondary-foreground" />
                </div>
                <h3 className="font-bold text-xl mb-3 group-hover:text-secondary transition-colors">
                  {feature.title}
                </h3>
                <p className="text-muted-foreground leading-relaxed">
                  {feature.description}
                </p>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Engagements Section */}
        <div className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-6 max-w-4xl mx-auto">
          {[
            { value: "9+", label: "Années d'expérience" },
            { value: "100%", label: "Équipe formée" },
            { value: "24/7", label: "Service disponible" },
            { value: "Nantes", label: "Secteur d'intervention" }
          ].map((stat, index) => (
            <div 
              key={index} 
              className="text-center p-6 rounded-xl bg-background/60 backdrop-blur-sm border border-secondary/20 hover:border-secondary/50 transition-all animate-fade-up"
              style={{ animationDelay: `${0.6 + index * 0.1}s` }}
            >
              <div className="text-4xl font-bold bg-gradient-secondary bg-clip-text text-transparent mb-2">
                {stat.value}
              </div>
              <div className="text-sm text-muted-foreground font-medium">
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default EcoSection;
